import React from 'react';
import { View, StyleSheet } from 'react-native';
import { isRowLayout } from '../../utilities/screen';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    // flex: 1,
    // flexBasis: 'auto',
    alignContent: 'center',
  },
  inner: {
    // flexDirection: isRowLayout ? 'row' : 'column',
    width: '100%',
    maxWidth: 1000,
    padding: isRowLayout ? 30 : 10,
    paddingVertical: isRowLayout ? 100 : 10,
    flex: 1,
    alignSelf: 'center',
  },
});

function Section(props) {
  return (
    <View
      style={[styles.container, { backgroundColor: props.backgroundColor }]}
    >
      <View style={[styles.inner, props.style]}>{props.children}</View>
    </View>
  );
}

export default Section;
